import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state: {
        //存放的键值对就是所要管理的状态
        address: 0,
        showtip: true,
        loading: false,
        headurl:'',
        totalPoint:''
    },
    mutations:{
        showLoading(state){
            
            state.loading = true    
        },
        hideLoading (state) {
            state.loading = false
        }
    }
})

export default store